export const ROLES_SISTEMA = Object.freeze({
  SYS_ADMIN: "SYS_ADMIN",
  COORDINADOR: "COORDINADOR",
  EJECUTIVO_FLOTILLA: "EJECUTIVO_FLOTILLA",
  GERENTE_CONTRALORIA: "GERENTE_CONTRALORIA",
  AUXILIAR_ADMIN: "AUXILIAR_ADMIN",
  ADMIN_TALLERES: "ADMIN_TALLERES",
  ADMIN_ESPECIAL: "ADMIN_ESPECIAL",
  SUBDIRECTOR_OPERACIONES: "SUBDIRECTOR_OPERACIONES",
  CLIENTE_GENERICO: "ROL_GESTION_SITT_CLIENTE",
});
